/**
 * Not swapped under the visual refresh (HNS-262): despite the names, these are 160x160 full-page
 * illustrations for the success and error result screens, not status glyphs at icon scale. Phosphor's
 * `CheckCircle`/`WarningCircle` are drawn for 16-24px and would look like a mistake at this size.
 */
import { createSvgIcon } from 'common/theme/utils';

import Error from './Error.svg?react';
import Success from './Success.svg?react';

export const SuccessIcon = createSvgIcon(Success, 'Success');
export const ErrorIcon = createSvgIcon(Error, 'Error');
